import axios from 'axios';

export const initializeCell = async (name) => {
    const { data } = await axios.post('/app/noteFunnel/initializeCell', name);

    return data;
};

export const getApplyNote = async (id) => {
    const { data } = await axios.get(`/app/noteFunnel/applyNote/${id}`);

    return data;
};

export const saveCell = async (id, actionType, actionDescription, creationNotes, assignmentUserId, notifyUsers) => {
    const { data } = await axios.put(`/app/noteFunnel/saveCell/${id}`, {
        actionType,
        actionDescription,
        creationNotes,
        assignmentUserId,
        notifyUsers,
    });

    return data;
};
